export var CONTENT_ANALYTICS_QUERY_NAMES = [
    'ctx.flybits.contentAnalytics.query.engaged',
    'ctx.flybits.contentAnalytics.query.fulfilled',
    'ctx.flybits.contentAnalytics.query.viewed',
    'ctx.flybits.contentAnalytics.query.componentEngaged',
    'ctx.flybits.contentAnalytics.query.componentFulfilled',
];
export var CONTENT_ANALYTICS_COMPONENT_QUERY_NAMES = [
    'ctx.flybits.contentAnalytics.query.componentEngaged',
    'ctx.flybits.contentAnalytics.query.componentFulfilled',
];
//# sourceMappingURL=contentAnalytics.js.map